// Which live PubNub / FCM payloads are messages (spec 2026-10-25-delete-sent-message, final review). Events ride the
// same channel as messages: a reaction or a deletion changes an existing message, and a future event kind an older
// bundle does not know carries no text or attachment either. Only a payload with content is a row, the latest
// message, an unread or a notification.

interface LivePayloadLike {
  text?: string | null;
  attachment?: { media?: unknown[] | null; link?: unknown; preview?: unknown } | null;
  reaction?: unknown;
  deletion?: unknown;
}

/** The payload carries text, media or a resolved link. */
export function hasMessageContent(p: LivePayloadLike | null | undefined): boolean {
  if (!p) return false;
  if (typeof p.text === "string" && p.text !== "") return true;
  const media = p.attachment?.media;
  if (Array.isArray(media) && media.length > 0) return true;
  return !!p.attachment?.link || !!p.attachment?.preview;
}

/** A message to show: not a known event (reaction, deletion) and it has content ([hasMessageContent]). */
export function isRenderableMessage(p: LivePayloadLike | null | undefined): boolean {
  return !!p && !p.reaction && !p.deletion && hasMessageContent(p);
}
